if (!customElements.get('lokt-launch-buybox')) {
  customElements.define('lokt-launch-buybox', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-buy-data]').textContent);
      this.form = this.querySelector('form');
      this.flavor = this.querySelector('[data-buy-flavor]');
      this.interval = this.querySelector('[data-buy-interval]');
      this.intervalChosen = false;
      this.button = this.querySelector('[data-buy-add]');
      this.sticky = this.querySelector('[data-buy-sticky]');
      this.products = this.data.products;
      this.mix = this.querySelector('[data-buy-mix]');
      this.mixRange = this.querySelector('[data-mix-range]');
      // SKU counts describe real bundle components, never cart line properties.
      if (this.data.mode === 'pouches') this.products.forEach(p => p.variants.forEach(v => {
        const counts = v.sku?.match(/-E(\d+)-V(\d+)$/);
        if (counts && Number(counts[1]) + Number(counts[2]) === p.count) v.espresso = Number(counts[1]);
        else if (/^L50-CVB-01C$/.test(v.sku)) v.espresso = 0;
        else if (/^L50-DE-01C$|^LKT-(STARTER|DISCOVERY|REFILL)-DE\d+$/.test(v.sku)) v.espresso = p.count;
      }));
      // Retired 20% can plans are excluded from the launch UI pending catalog cutover.
      this.products.forEach(p => p.variants.forEach(v => { v.plans = v.plans.filter(a => ![26823033050, 26823065818, 26823098586].includes(a.id)); }));
      // Single cans and Discovery are one-time offers; ignore legacy can plans.
      if (this.data.mode === 'pouches') this.products.filter(p => p.count < 5).forEach(p => p.variants.forEach(v => { v.plans = []; }));
      this.pack = this.products.find(p => p.handle === this.dataset.initialHandle) || this.products.find(p => p.count === 5) || this.products[0];
      if (!this.pack) return;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.addEventListener('change', e => {
        if (e.target.matches('[data-pack-choice]')) {
          const preferred = Number.isInteger(this.variant?.espresso) ? this.variant.espresso / this.pack.count : this.variant?.title.split(' · ')[0];
          this.pack = this.products.find(p => p.handle === e.target.value);
          this.setVariants(preferred);
          this.event('lokt_pack_selected', { pack: this.pack.count, source: 'buybox' });
        } else if (e.target === this.flavor) {
          this.variant = this.pack.variants.find(v => String(v.id) === this.flavor.value);
          this.setPlans();
        }
        this.paint();
        if (e.target === this.interval || e.target.matches('input[name^="purchase-choice-"]')) {
          if (e.target === this.interval) this.intervalChosen = true;
          this.event('lokt_plan_selected', { pack: this.pack.count, plan: this.plan?.id || 'onetime', interval_weeks: this.interval.selectedOptions[0]?.dataset.weeks || '' });
        }
        if (e.target === this.flavor) this.event('lokt_flavor_selected', { variant_id: this.variant.id, pack: this.pack.count });
      }, opts);
      this.mix?.addEventListener('click', e => {
        const preset = e.target.closest('[data-mix-preset]');
        if (!preset || this.busy) return;
        const count = preset.dataset.mixPreset === 'espresso' ? this.pack.count : preset.dataset.mixPreset === 'vanilla' ? 0 : Math.ceil(this.pack.count / 2);
        this.chooseMix(count, 'preset');
      }, opts);
      this.mixRange?.addEventListener('input', () => {
        if (!this.busy) this.chooseMix(Number(this.mixRange.value), 'builder');
      }, opts);
      this.form.addEventListener('submit', e => this.submit(e), opts);
      this.querySelector('[data-buy-sticky-button]').addEventListener('click', e => {
        this.event('lokt_sticky_atc', { pack: this.pack.count, variant_id: this.variant.id });
        // The cart drawer hands focus back to the control that opened it. The bar stays
        // on screen, so returning there never scrolls the shopper down to the in-page Add.
        this.trigger = e.currentTarget;
        this.form.requestSubmit();
      }, opts);
      this.querySelector('[data-buy-sticky-edit]').addEventListener('click', () => {
        this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        (this.querySelector('[data-pack-choice]:checked') || this.flavor).focus({ preventScroll: true });
      }, opts);
      this.setVariants();
      const params = new URL(location.href).searchParams;
      const request = params.get('pack') || this.dataset.presetPack;
      const fromUrl = this.products.find(p => String(p.count) === request);
      if (fromUrl && this.data.mode === 'pouches') {
        this.pack = fromUrl;
        this.setVariants();
      }
      // Campaign presets change flavor/pack only. A subscription is always opt-in.
      if (this.data.mode === 'pouches') {
        const flavor = params.get('flavor') || this.dataset.presetFlavor;
        const requestedVariant = this.products.flatMap(p => p.variants.map(v => ({p,v}))).find(({v}) => String(v.id) === params.get('variant'));
        if (requestedVariant) {
          this.pack = requestedVariant.p; this.setVariants(); this.variant = requestedVariant.v; this.flavor.value = this.variant.id; this.setPlans();
        } else if (flavor === 'vanilla' || flavor === 'both' || flavor === 'espresso') {
          this.chooseMix(flavor === 'vanilla' ? 0 : flavor === 'espresso' ? this.pack.count : Math.ceil(this.pack.count / 2), 'url');
        }
      }
      if (params.get('purchase') === 'subscribe' && this.variant.plans.length) this.querySelector('input[value=subscribe]').checked = true;
      this.paint();
      const footer = document.querySelector('footer.footer');
      const start = this.closest('.shopify-section') || this;
      // Pouches: the first pouches box shows its bar whenever the offer has been reached and
      // the in-page Add is off-screen. MIX, Desk Stack and later boxes show it after Add.
      this.stickyRule = this.dataset.stickyRule === 'offscreen' && document.querySelector('lokt-launch-buybox[data-sticky-rule=offscreen]') === this ? 'offscreen' : 'past';
      this.measureSticky = () => {
        const y = window.scrollY;
        const b = this.button.getBoundingClientRect();
        this.buttonTop = b.top + y;
        this.buttonBottom = b.bottom + y;
        this.startTop = start.getBoundingClientRect().top + y;
        this.topInset = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
        // Landing pages hide the footer; there the page end plays its part, so the bar steps
        // aside before it can cover the last lines (legal links) of the page.
        this.footerTop = footer?.getClientRects().length ? footer.getBoundingClientRect().top + y : document.documentElement.scrollHeight - 96;
        this.updateStickyVisibility(true);
      };
      // Measure only when layout changes. Scrolling uses cached document
      // positions, so fast jumps and rotation cannot strand the bar at the footer.
      this.stickyLayoutObserver = new ResizeObserver(this.measureSticky);
      for (const element of [this, this.sticky, document.querySelector('main'), footer]) {
        if (element) this.stickyLayoutObserver.observe(element);
      }
      window.addEventListener('scroll', () => this.updateStickyVisibility(), { ...opts, passive: true });
      window.addEventListener('resize', this.measureSticky, opts);
      this.measureSticky();
    }
    disconnectedCallback() { this.stickyLayoutObserver?.disconnect(); this.abort?.abort(); this.ready = false; }
    updateStickyVisibility(remeasure) {
      const y = window.scrollY, vh = window.innerHeight, nearFooter = y + vh >= this.footerTop;
      // lokt-a11y.js keeps html scroll-padding-top in step with the header as it hides and returns.
      const inset = parseFloat(document.documentElement.style.scrollPaddingTop) || this.topInset;
      const hide = this.stickyRule === 'offscreen'
        ? y < 64 || nearFooter || this.startTop >= y + vh || (this.buttonTop < y + vh && this.buttonBottom > y + inset)
        : nearFooter || y < this.buttonBottom;
      // Scrolling only flips visibility; a layout pass also refreshes the published height.
      const changed = this.sticky.hidden !== hide;
      if (!changed && (hide || !remeasure)) return;
      this.sticky.hidden = hide;
      const h = hide ? 0 : this.sticky.offsetHeight;
      if (!changed && h === this.stickyHeight) return;
      this.stickyHeight = h;
      document.documentElement.classList.toggle('lokt-buy-sticky-on', !hide);
      document.documentElement.style.setProperty('--lokt-buy-sticky-h', h + 'px');
      this.dispatchEvent(new CustomEvent('lokt:sticky-change', { bubbles: true, detail: { visible: !hide, height: h } }));
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD', minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100);
    }
    // Mirrors snippets/lokt-ship-promise.liquid forms 'short' and 'below'. A threshold of 0
    // means no free tier (Theme settings > LOKT commerce), so the flat rate always applies.
    shipLine(cents) {
      const free = parseInt(this.dataset.freeShip || '0', 10);
      const flat = parseInt(this.dataset.flatRate || '495', 10);
      if (free > 0 && cents >= free) return 'Free shipping in the contiguous US.';
      return `${this.money(flat)} shipping in the contiguous US.${free > 0 ? ` Free from ${this.money(free)}.` : ''}`;
    }
    setVariants(preferred) {
      const requested = typeof preferred === 'number' ? this.pack.variants.find(v => v.espresso === Math.round(preferred * this.pack.count)) : this.pack.variants.find(v => v.available && v.title.split(' · ')[0] === preferred);
      this.variant = requested
        || this.pack.variants.find(v => v.available) || this.pack.variants[0];
      this.flavor.replaceChildren(...this.pack.variants.map(v => {
        const title = v.title === 'Default Title' && this.data.mode === 'stack' ? 'Espresso pouches + Dark Mocha Protein Coffee' : v.title;
        const option = new Option(title + (v.available ? '' : ' · sold out'), v.id);
        option.disabled = !v.available;
        option.selected = v.id === this.variant.id;
        return option;
      }));
      const flavorNote = this.querySelector('[data-buy-flavor-note]');
      const hasChoice = this.pack.variants.filter(v => v.available).length > 1;
      this.flavor.hidden = !hasChoice;
      flavorNote.hidden = hasChoice;
      flavorNote.textContent = this.flavor.selectedOptions[0]?.textContent || '';
      this.setPlans();
    }
    chooseMix(count, source) {
      const next = this.pack.variants.find(v => v.espresso === count);
      if (!next) return;
      this.variant = next;
      this.flavor.value = String(next.id);
      this.setPlans();
      this.paint();
      this.event('lokt_flavor_selected', { pack: this.pack.count, espresso: count, vanilla: this.pack.count - count, source });
    }
    paintMix() {
      if (!this.mix) return;
      const valid = Number.isInteger(this.variant.espresso) && this.pack.variants.some(v => v.espresso === 0);
      this.mix.hidden = !valid;
      this.querySelector('[data-buy-flavor-label]').hidden = valid;
      if (!valid) return;
      this.flavor.hidden = true;
      this.querySelector('[data-buy-flavor-note]').hidden = true;
      const e = this.variant.espresso, v = this.pack.count - e;
      this.mixRange.max = this.pack.count;
      this.mixRange.value = e;
      this.mixRange.setAttribute('aria-valuetext', `${e} Espresso and ${v} Cold Vanilla Brew cans`);
      this.querySelector('[data-mix-count]').textContent = `${e} of ${this.pack.count}`;
      this.querySelector('[data-mix-custom]').hidden = this.pack.count === 1;
      this.querySelector('[data-mix-summary]').textContent = `${e ? `${e} Espresso` : ''}${e && v ? ' + ' : ''}${v ? `${v} Cold Vanilla Brew` : ''} · ${this.pack.count * 20} pouches${this.variant.available ? '' : ' · This mix is sold out'}`;
      this.mix.querySelectorAll('[data-mix-preset]').forEach(b => {
        const preset = b.dataset.mixPreset;
        const count = preset === 'espresso' ? this.pack.count : preset === 'vanilla' ? 0 : Math.ceil(this.pack.count / 2);
        b.hidden = preset === 'both' && this.pack.count === 1;
        b.disabled = this.busy || !this.pack.variants.some(x => x.espresso === count && x.available);
        b.setAttribute('aria-pressed', String(preset === 'espresso' ? e === this.pack.count : preset === 'vanilla' ? e === 0 : e > 0 && e < this.pack.count));
      });
    }
    setPlans() {
      const oldWeeks = this.intervalChosen ? this.interval.selectedOptions[0]?.dataset.weeks : null;
      const recommended = this.data.mode === 'protein' ? '4' : this.data.mode === 'pouches' && this.pack.count >= 10 ? '12' : '6';
      this.interval.replaceChildren(...this.variant.plans.map(p => {
        const weeks = (p.name.match(/every (\d+) weeks?/i) || [])[1];
        const option = new Option(weeks ? `${weeks} weeks${weeks === recommended ? ' · starting schedule' : ''}` : p.name, p.id);
        option.dataset.weeks = weeks || '';
        return option;
      }));
      const options = Array.from(this.interval.options);
      const selected = options.find(o => o.dataset.weeks === (oldWeeks || recommended)) || options[0];
      if (selected) selected.selected = true;
      if (!this.variant.plans.length) this.querySelector('input[value="once"]').checked = true;
      this.querySelector('[data-buy-purchase]').hidden = !this.variant.plans.length;
    }
    paint() {
      this.paintMix();
      this.paintContents();
      this.paintGallery();
      const subscribed = this.querySelector('input[value="subscribe"]').checked && this.variant.plans.length > 0;
      const plan = this.variant.plans.find(p => String(p.id) === this.interval.value);
      this.plan = subscribed ? plan : null;
      this.price = this.plan?.price ?? this.variant.price;
      const weeks = this.interval.selectedOptions[0]?.dataset.weeks;
      this.querySelector('[data-buy-id]').value = this.variant.id;
      const planInput = this.querySelector('[data-buy-plan]');
      planInput.disabled = !this.plan;
      planInput.value = this.plan?.id || '';
      this.querySelectorAll('[data-pack-choice]').forEach(r => { r.checked = r.value === this.pack.handle; });
      this.querySelectorAll('[data-pack-price]').forEach(node => {
        const p = this.products.find(p => p.handle === node.dataset.packPrice);
        const v = p.variants.find(v => v.available) || p.variants[0];
        const matching = v.plans.find(a => a.name.match(new RegExp(`every ${weeks || '6'} weeks?`, 'i'))) || v.plans[0];
        const shown = subscribed && matching ? matching.price : v.price;
        node.textContent = this.money(shown);
        const unit = this.querySelector(`[data-pack-unit="${p.handle}"]`);
        if (unit) unit.textContent = `${this.money(Math.round(shown / (p.count * 20)))} a pouch`;
        // The single-can saving is a one-time comparison; it steps aside while a plan price shows.
        const save = this.querySelector(`[data-pack-save="${p.handle}"]`);
        if (save) save.hidden = shown !== v.price;
      });
      this.querySelector('[data-buy-price]').textContent = this.money(this.price);
      let units;
      if (this.data.mode === 'pouches') units = `${this.pack.count * 20} pouches · ${this.money(Math.round(this.price / (this.pack.count * 20)))} a pouch`;
      else if (this.data.mode === 'protein') units = `1kg · about 28 servings · ${this.money(Math.round(this.price / (1000 / 36)))} a serving`;
      else units = '5 cans of coffee pouches + 1 bag of Protein Coffee';
      this.querySelector('[data-buy-unit]').textContent = units;
      this.querySelector('[data-once-price]').textContent = this.money(this.variant.price);
      this.querySelector('[data-sub-price]').textContent = plan ? this.money(plan.price) : '';
      this.querySelector('[data-sub-saving]').textContent = plan ? `Save ${this.money(this.variant.price - plan.price)} each delivery` : '';
      this.querySelector('[data-buy-schedule]').hidden = !subscribed;
      const recurring = this.plan?.adjustments?.[1]?.price ?? this.price;
      this.querySelector('[data-buy-recurrence]').textContent = subscribed ? `${this.money(this.price)} today, then ${this.money(recurring)} every ${weeks ? `${weeks} weeks` : plan.name}. ${this.shipLine(recurring)}` : '';
      this.querySelector('[data-buy-delivery]').textContent = this.shipLine(this.price);
      this.querySelector('[data-buy-label]').textContent = this.busy ? 'Adding your coffee…' : !this.variant.available ? 'Currently unavailable' : `${subscribed ? 'Subscribe' : 'Add'} ${this.data.mode === 'pouches' ? this.pack.name : this.data.mode === 'protein' ? '1 bag' : 'the stack'} · ${this.money(this.price)}`;
      this.button.disabled = this.busy || !this.variant.available;
      this.querySelector('[data-buy-sticky-title]').textContent = this.pack.name;
      const ce = this.variant.espresso, cv = this.pack.count - ce;
      this.querySelector('[data-buy-sticky-selection]').textContent = this.data.mode === 'pouches' && Number.isInteger(ce) ? (cv === 0 ? `${ce} × Espresso` : ce === 0 ? `${cv} × Cold Vanilla Brew` : `${ce} Espresso + ${cv} Vanilla`) : this.variant.title.replace('Default Title', 'Espresso + Dark Mocha');
      const stickyButton = this.querySelector('[data-buy-sticky-button]');
      stickyButton.textContent = this.busy ? 'Adding…' : !this.variant.available ? 'Unavailable' : subscribed ? 'Subscribe' : 'Add to cart';
      stickyButton.disabled = this.busy || !this.variant.available;
      this.querySelector('[data-buy-sticky-price]').textContent = `${this.money(this.price)}${subscribed ? ` every ${weeks || ''} weeks` : ' · one time'}`;
      this.dispatchEvent(new CustomEvent('lokt:offer-change', { bubbles: true, detail: { variantId: this.variant.id, price: this.price, count: this.pack.count, sellingPlanId: this.plan?.id || null } }));
    }
    paintGallery() {
      if (this.paintedVariant === this.variant.id) return;
      const scope = this.closest('.shopify-section');
      const gallery = scope?.querySelector('media-gallery');
      if (!gallery) return;
      if (this.data.mode === 'pouches') {
        const data = scope.querySelector('[data-lokt-flavor-images]');
        if (!data) return;
        this.flavorImages ||= JSON.parse(data.textContent);
        const e = this.variant.espresso;
        const v = this.pack.count - e;
        // Square galleries 2026-09-27: four slots per flavour set, in gallery order, from
        // snippets/lokt-product-images via lokt-flavor-image-data, so Liquid and JS cannot drift.
        // Owner 2026-09-27: the flavour's model photo is slide 2 of every set.
        const set = e === 0 ? 'vanilla' : v === 0 ? (this.pack.count !== 5 ? 'espressoOtherPack' : 'espresso') : (e === 3 && v === 2 ? 'starterMix' : 'both');
        // A listed file missing from Content > Files has src null. The Liquid gallery skips it
        // too, so drop it here and slots stay aligned with the rendered slides.
        const photos = (this.flavorImages.sets?.[set] || []).filter(photo => photo?.src);
        scope.querySelectorAll('media-gallery').forEach(g => {
          // Slide keys (data-media-id / data-lokt-key) never change: thumbnail clicks are bound
          // to them at construction (media-gallery.js). A repaint swaps the image and rewrites
          // data-lokt-file and data-alt only. Match files exactly, never by substring.
          const slides = Array.from(g.querySelectorAll('.product__media-list > [data-media-id]'));
          photos.slice(0, 4).forEach((photo, index) => {
            const slide = slides[index];
            if (!photo?.src || !slide) return;
            const patch = (img, thumbnail = false) => {
              if (!img) return;
              const url = new URL(photo.src, location.href);
              if (new URL(img.src, location.href).pathname === url.pathname) { img.alt = photo.alt || img.alt; return; }
              const source = width => { url.searchParams.set('width', Math.min(width, photo.width)); return url.href; };
              // Up to about 2x the approved masters, so desktop Retina can use the 2x files.
              const widths = thumbnail ? [100, 200, 300] : [360, 540, 720, 960, 1200, 1400, 1800, 2200, 2600, 3000].filter(w => w < photo.width).concat(photo.width);
              const srcset = widths.map(w => `${source(w)} ${w}w`).join(', ');
              if (img.srcset !== srcset) {
                img.srcset = srcset;
                img.src = source(thumbnail ? 200 : 960);
                img.alt = photo.alt || '';
                img.width = photo.width;
                img.height = photo.height;
              }
            };
            patch(slide.querySelector('.product__media img'));
            patch(slide.querySelector('template[data-lokt-slide]')?.content.querySelector('img'));
            const thumb = Array.from(g.querySelectorAll('[data-target]')).find(n => n.dataset.target === slide.dataset.mediaId);
            patch(thumb?.querySelector('img'), true);
            if (thumb) { thumb.dataset.alt = photo.alt || ''; thumb.dataset.loktFile = photo.file; }
            slide.dataset.alt = photo.alt || '';
            slide.dataset.loktFile = photo.file;
            // Theme modals move under body, outside the product section.
            const modalId = slide.querySelector('modal-opener')?.dataset.modal;
            const modal = modalId ? document.querySelector(modalId) : null;
            const zoom = slide.dataset.loktKey ? modal?.querySelector(`img[data-media-id="${slide.dataset.loktKey}"]`) : null;
            patch(zoom);
            if (zoom) zoom.dataset.loktFile = photo.file;
          });
          // Return to the flavor photo after a choice, without moving the page.
          if (this.paintedVariant && slides[0] && g.setActiveMedia) g.setActiveMedia(slides[0].dataset.mediaId, false, false, null, true);
        });
        this.paintedVariant = this.variant.id;
      } else if (this.data.mode === 'protein') {
        // MIX flavour jump: the variant's primary file from data-lokt-variant-files
        // (snippets/product-media-gallery, from lokt-product-images), matched exactly.
        let map = {};
        try { map = JSON.parse(gallery.dataset.loktVariantFiles || '{}'); } catch (_) { map = {}; }
        const file = map[this.variant.id];
        const slide = file && Array.from(gallery.querySelectorAll('.product__media-list > [data-lokt-file]')).find(n => n.dataset.loktFile === file);
        if (slide && gallery.setActiveMedia) {
          gallery.setActiveMedia(slide.dataset.mediaId, false, false, null, true);
          this.paintedVariant = this.variant.id;
        }
      }
    }
    paintContents() {
      if (this.data.mode !== 'pouches') return;
      const e = this.variant.espresso;
      if (!Number.isInteger(e)) return;
      const v = this.pack.count - e;
      const scope = this.closest('.shopify-section') || this;
      scope.querySelectorAll('[data-lokt-selected-taste]').forEach(node => {
        node.textContent = e === 0 ? 'Cold Vanilla Brew. Coffee meets vanilla.' : v === 0 ? 'Espresso. Deep roast. Dry cocoa. A little caramel.' : 'Espresso and Cold Vanilla Brew. Two coffees, one box.';
      });
      scope.querySelectorAll('[data-pack-contents]').forEach(plate => {
        const set = (sel, text, hide) => { const n = plate.querySelector(sel); if (!n) return; if (text != null) n.textContent = text; if (hide != null) n.hidden = hide; };
        set('[data-contents-title]', this.pack.count === 1 ? 'Your single can' : `Inside your ${this.pack.name}`);
        set('[data-contents-total]', `${this.pack.count} ${this.pack.count === 1 ? 'can' : 'cans'} · ${this.pack.count * 20} pouches`);
        set('[data-contents-espresso]', `${e} Espresso`, e === 0);
        set('[data-contents-vanilla]', `${v} Cold Vanilla Brew`, v === 0);
        set('[data-contents-case]', null, this.pack.count !== 5);
      });
      this.paintKitImage(scope, e, v);
    }
    // Kit row thumbnail (owner 2026-09-27): the four small-size frames ride on the figure as
    // data-kit-{box,espresso,vanilla,both} (snippets/lokt-launch-buybox.liquid). The five-tin box
    // only for an all-Espresso Starter Kit, the flavour still life for one flavour, both tins for a mix.
    paintKitImage(scope, e, v) {
      const figure = this.querySelector('[data-kit-image]');
      const img = figure?.querySelector('img');
      if (!img) return;
      const key = e === 0 ? 'Vanilla' : v > 0 ? 'Both' : this.pack.count === 5 ? 'Box' : 'Espresso';
      const srcset = figure.dataset[`kit${key}`];
      if (!srcset) return;
      if (img.getAttribute('srcset') !== srcset) {
        img.srcset = srcset;
        img.src = (srcset.split(', ').find(c => c.endsWith(' 240w')) || srcset).split(' ')[0];
      }
      img.alt = figure.dataset[`kit${key}Alt`] || '';
    }
    // In-place presets from links marked data-lokt-preset (flavour cards, "Get 5 cans", the
    // coffee finder). Pack and flavour change; the one-time or subscription choice is kept.
    preset({ pack, flavor, source }) {
      if (this.busy || this.data.mode !== 'pouches') return;
      const next = pack && this.products.find(p => String(p.count) === String(pack));
      if (next && next !== this.pack) {
        const pref = Number.isInteger(this.variant?.espresso) ? this.variant.espresso / this.pack.count : this.variant?.title.split(' · ')[0];
        this.pack = next;
        this.setVariants(pref);
        this.event('lokt_pack_selected', { pack: next.count, source });
      }
      const c = flavor === 'vanilla' ? 0 : flavor === 'espresso' ? this.pack.count : flavor === 'both' ? Math.ceil(this.pack.count / 2) : null;
      if (c !== null) this.chooseMix(c, source);
      this.paint();
      this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      this.querySelector('[data-pack-choice]:checked')?.focus({ preventScroll: true });
    }
    event(name, detail) {
      // Use the shared QA guard and queue; never send audit clicks to customer analytics.
      const payload = { ...detail, variant_id: detail.variant_id || this.variant?.id, section: this.id.replace('lokt-launch-', '') };
      if (window.LoktEvents) window.LoktEvents.publish(name, payload);
      else document.dispatchEvent(new CustomEvent('lokt:track', { detail: { name, data: payload } }));
    }
    async submit(e) {
      e.preventDefault();
      const trigger = this.trigger || e.submitter || this.button;
      this.trigger = null;
      if (this.busy || !this.variant.available) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.paint();
      const error = this.querySelector('[data-buy-error]');
      error.textContent = '';
      const drawer = document.querySelector('cart-drawer,cart-notification');
      const data = new FormData(this.form);
      const addedOffer = { variantId: this.variant.id, pack: this.pack.count, price: this.price, sellingPlanId: this.plan?.id || null };
      const choices = Array.from(this.form.querySelectorAll('fieldset, select'));
      const disabled = choices.map(node => node.disabled);
      choices.forEach(node => { node.disabled = true; });
      data.delete(`pack-choice-${this.id.replace('lokt-launch-', '')}`);
      data.delete(`purchase-choice-${this.id.replace('lokt-launch-', '')}`);
      const sections = drawer?.getSectionsToRender?.().map(s => s.id);
      if (sections?.length) {
        data.set('sections', sections.join(','));
        data.set('sections_url', location.pathname);
      }
      try {
        // Both paths POST the paid line to /cart/add.js through window.fetch, which Shopify's
        // web-pixels manager wraps: that is the only thing that reports product_added_to_cart
        // (Meta AddToCart). Never route the paid add through a saved fetch (snippets/lokt-gifts.liquid).
        const response = window.LoktGifts?.add ? await window.LoktGifts.add(data, {productId: this.pack.id}) : await fetch(this.form.action + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
        const result = await response.json();
        if (result.items?.[0]) { result.id = result.items[0].id; result.key = result.items[0].key; }
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this pack. Please try again.');
        this.event('lokt_offer_added', addedOffer);
        if (drawer?.renderContents && result.sections) {
          drawer.setActiveElement?.(trigger);
          drawer.classList.remove('is-empty');
          try { drawer.renderContents(result); } catch (_) { location.assign((window.Shopify?.routes?.root || '/') + 'cart'); return; }
          drawer.classList.remove('is-empty');
        } else location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (err) {
        error.textContent = err.message || 'Unable to add this pack. Please try again.';
        error.scrollIntoView({block:'center',behavior:'auto'});
      } finally {
        this.busy = false;
        choices.forEach((node, index) => { node.disabled = disabled[index]; });
        this.button.removeAttribute('aria-busy');
        this.paint();
      }
    }
  });
  // Links with data-lokt-preset set the page's first pouches buy box in place: no navigation,
  // so ?view and utm_* stay. Without a pouches box, or on a modified click, the href is followed.
  if (!window.__loktPresetLinks) {
    window.__loktPresetLinks = true;
    document.addEventListener('click', e => {
      const a = e.target.closest('a[data-lokt-preset]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const box = document.querySelector('lokt-launch-buybox[data-mode=pouches]');
      if (!box?.preset || !box.pack) return;
      e.preventDefault();
      a.closest('dialog')?.close();
      box.preset({ pack: a.dataset.pack, flavor: a.dataset.flavor, source: a.dataset.loktPreset });
    });
  }
}
